import HomeHeader from "../components/HomeHeader";
import React from "react";

const Sites = () => {
    return(
        <>
            <HomeHeader/>
            <div className="container">
                <h1>Sites</h1>
            </div>
        </>
    );
};

export default Sites;